<template>
  <v-container class="max-container">
      <v-row>          
          <v-col v-if="!($vuetify.breakpoint.sm || $vuetify.breakpoint.xs)">
              <span class="vcontainer__vrow__title">Como foi sua experiência?</span>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'flex-col-center no-pd-t' : 'flex-col-start'">
            <span class="vcontainer__vrow__subtitle"> Qual a probabilidade de você recomendar a {{ currentCompany.name }} para um amigo? </span>

            <v-item-group class="">

                <v-col class="flex-row-start flex-wrap no-pd-l no-pd-b" xs="" sm="12" md="12" lg="12" xl="12" >
                    <v-item v-for="note in ratingList" :key="note.note">                    
                        <v-chip :color="note.active? 'var(--cor--amarelo)' : ''" class=" mg-chip-rate " :input-value="note.active" @click="changeRating(note)">
                            <span class="font-black">
                                {{note.note}}
                            </span>
                        </v-chip>                                            
                    </v-item>
                </v-col>
            </v-item-group>              
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'flex-col-center' : 'flex-col-start'">
              <span class="vcontainer__vrow__subtitle"> O que poderia ser melhor? </span>

                <v-item-group multiple class="item-group__align">

                    <v-col class="no-pd-l no-pd-r no-pd-b" xs="12" sm="12" md="9" lg="9" xl="9">
                        <v-item v-for="improvement in improvementsList" :key="improvement.name" v-slot:default="{ active, toggle }">
                            <v-chip :color="improvement.active ? 'var(--cor--amarelo)' : ''" class=" mg-chip " :input-value="improvement.active" @click="toggle, changeImprovementValue(improvement)">
                                <span class="font-black">
                                    {{ improvement.name }}
                                </span>
                            </v-chip>
                        </v-item>   
                    </v-col> 
                </v-item-group>
          </v-col>
      </v-row>

      <v-row class="">
          <v-col xs="12" sm="12" md="12" lg="12" :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'flex-row-center' : 'flex-row-start'">
              <span class="vcontainer__vrow__subtitle"> Gostaria de comentar algo? </span> 
              <span class="vcontainer_vrow_subtitle__option">(opcional)</span>
          </v-col>

          <v-col xs="12" sm="12" md="11" lg="10" class="no-pd-b">
            <v-textarea 
                :counter="max"
                v-model="messageObject.message"
                :error-messages="messageErrors"
                @change="$v.messageObject.message.$touch()"
                @blur="$v.messageObject.message.$touch()"
                outlined>                
            </v-textarea>
          </v-col>
      </v-row>
 
      <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" class="flex-row-start no-pd-t">
            <v-btn :color="currentCompany.buttonsColor" :loading="btnLoading" :disabled="(maxCaracters && messageObject.rating == null) || messageObject.rating == null || maxCaracters" class="w-btn" @click="submitRating">
                <span class="text-none text-white"> Enviar </span>
            </v-btn>            
          </v-col> 
      </v-row>
  </v-container>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Plugins
import { maxLength } from 'vuelidate/lib/validators'

//Services
import { updateReviewByIdAndCompanyIdAndContactId, getAllReviewImprovements } from "./service/rating.service";

export default {
    name: 'Rating',
    computed: {
        ...mapGetters('authenticateStore', {
            currentCompany: 'get_currentCompany',
            currentUser: 'get_currentUserId'
            }
        ),
        messageErrors() {
            const errors = []
            !this.$v.messageObject.message.maxLength && errors.push('Limite de 1024 caracteres')
            return errors
        }
    },
    validations: {
        messageObject: {
            message: { maxLength: maxLength(1024) }
        }
    },
    watch: {
        messageObject: {
            deep: true,
            handler() {
                this.messageObject.message.length <= 1024 ? this.maxCaracters = false : this.maxCaracters = true
            }
        }
    },
    data: () => ({
        improvementsList: [],
        ratingList: [ 
            {note: 1,  active:  false},
            {note: 2,  active:  false},
            {note: 3,  active:  false},
            {note: 4,  active:  false},
            {note: 5,  active:  false},
            {note: 6,  active:  false},
            {note: 7,  active:  false},
            {note: 8,  active:  false},
            {note: 9,  active:  false},
            {note: 10, active:  false},
        ],
        messageObject: {
            message:             null,
            rating:              null
        },
        max:                     1024,
        maxCaracters:            null,
        contactId:               null,
        ratingId:                null,
        btnLoading:              false

    }),
    created() {
        this.getScreenInfo() 
    },
    methods: {
        ...mapActions('ratingLoaderStore', ['SET_RATING_STATE']),
        changeImprovementValue(improvement) {
            var activating = improvement.active
            this.improvementsList.forEach( element => {
                    element.active = false;
                }
            )
            improvement.active = !activating
            activating == false ? this.messageObject.improvementId = improvement.id : this.messageObject.improvementId = null
        },
        changeRating(rating){
            this.ratingList.forEach( element => {
                    element.active = false;
                }
            )
            this.messageObject.rating = rating.note
            rating.active = true
        }, 
        getScreenInfo(){
            (this.$route.query.id == null) ? this.$router.push( {path: '/inicio'}) : this.ratingId = this.$route.query.id
            
            if(this.$route.query.contactId != null){
                this.contactId = this.$route.query.contactId;

            } else {
                this.currentUser == null ? this.$router.push( {path: '/inicio'}) : this.contactId = this.currentUser
            }

            this.SET_RATING_STATE(true)
            this.getImprovements()
        },
        submitRating() {
            this.btnLoading = true
            if(this.ratingId != null && this.messageObject.rating != null ) {
                updateReviewByIdAndCompanyIdAndContactId(this.currentCompany.id, this.contactId, this.ratingId, this.messageObject )
                    .then( success => {
                            this.$toasted.show('Avaliação enviada com sucesso!', { type: 'success' } )
                            this.btnLoading = false
                            this.$router.push( {path: '/inicio'})
                        }
                    )
                    .catch( error => {
                            if (error != null) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }
                            this.btnLoading = false
                        }
                    )
            }else{
                this.$toasted.show('É obrigatório selecionar uma nota!', { type: 'error' } )
            }

        },
        getImprovements() {
            getAllReviewImprovements()
            .then( success => {
                    success.data.forEach( element => {
                            element.active = false;
                        }
                    )
                    this.improvementsList = success.data
                }
            )
        }
    }
}
</script>

<style scoped>
::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    color:black;;
}
::v-deep .custom-btn.theme--light.v-btn {
    color: var(--cor--branco);
}
::v-deep .v-chip:before {
    background-color: white !important;
}
.mg-chip-rate.v-chip.v-size--default{
    background-color: white;
    border: 1px solid var(--cor--amarelo);
}
.mg-chip.v-chip.v-size--default{
    background-color: white;
    border: 1px solid var(--cor--preta);
}

.mg-chip-rate{
    margin: 6px !important;
}
.mg-chip {
    margin: 4px !important;
    padding: 18px !important;
    border-radius: 6px !important;
}
.w-btn {
    width: 170px;
}
.vcontainer__vrow__title {
    font-weight: 800;
    font-size: 22px;
}
.vcontainer__vrow__subtitle {
    font-weight: bold;
    font-size: 18px;
}
.vcontainer_vrow_subtitle__option {
    font-size: 18px;
    font-weight: 500;
    padding-left: 6px;
}
</style>